import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { FiberManualRecord } from '@mui/icons-material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import { GET_STATUS_LABEL, QUOTE_STATUS_ARRAY } from '@/common/utils/Constants/Constants'

const CommonProjectStatusStyles = {
    fontWeight: '500',
    fontSize: '0.75rem',
}

const classes = {
    text: {
        color: 'text.primary',
    },
    NotCalculated: {
        color: '#F78F1E',
        ...CommonProjectStatusStyles,
    },
    Calculated: {
        color: '#007DAB',
        ...CommonProjectStatusStyles,
    },
    Ordered: {
        color: '#00BE35',
        ...CommonProjectStatusStyles,
    },
    Invoiced: {
        color: '#1EBEF7',
        ...CommonProjectStatusStyles,
    },
    Voided: {
        color: '#C62828',
        ...CommonProjectStatusStyles,
    },
    Issued: {
        color: '#0288D1',
        ...CommonProjectStatusStyles,
    },
    Lost: {
        color: '#800080',
        ...CommonProjectStatusStyles,
    },
    Cancelled: {
        color: '#E12626',
        ...CommonProjectStatusStyles,
    },
    PendingOrderConfirmation: {
        color: '#203E96',
        ...CommonProjectStatusStyles,
    },
    Rejected: {
        color: '#130F0F',
        ...CommonProjectStatusStyles,
    },
}

const QuoteStatusIcon = forwardRef(({ className, value }, ref) => {
    const { t } = useTranslation()

    let projectStatusStyle = undefined
    let label = ''
    switch (value) {
        case QUOTE_STATUS_ARRAY.NotCalculated:
            projectStatusStyle = classes.NotCalculated
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Calculated:
            projectStatusStyle = classes.NotCalculated
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Ordered:
            projectStatusStyle = classes.Ordered
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Invoiced:
            projectStatusStyle = classes.Invoiced
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Voided:
            projectStatusStyle = classes.Voided
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Lost:
            projectStatusStyle = classes.Lost
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Cancelled:
            projectStatusStyle = classes.Cancelled
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.PendingOrderConfirmation:
            projectStatusStyle = classes.PendingOrderConfirmation
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Rejected:
            projectStatusStyle = classes.Rejected
            label = t(GET_STATUS_LABEL(value))
            break
        case QUOTE_STATUS_ARRAY.Issued:
            projectStatusStyle = classes.Issued
            label = t(GET_STATUS_LABEL(value))
            break
        default:
            break
    }
    return (
        <Box sx={className}>
            {value !== undefined ? (
                <Box
                    alignItems="center"
                    data-testid="quote-status-indicator"
                    display="flex"
                    justifyContent="center"
                    sx={projectStatusStyle}
                >
                    <FiberManualRecord style={{ fontSize: 16 }} />
                    <Box
                        component={Typography}
                        px={1}
                        style={{ color: 16 }}
                        sx={classes.text}
                        variant="body2"
                    >
                        {label}
                    </Box>
                </Box>
            ) : null}
        </Box>
    )
})

QuoteStatusIcon.displayName = 'QuoteStatusIcon'

QuoteStatusIcon.propTypes = {
    className: PropTypes.object,
    value: PropTypes.oneOf([
        QUOTE_STATUS_ARRAY.NotCalculated,
        QUOTE_STATUS_ARRAY.Calculated,
        QUOTE_STATUS_ARRAY.Ordered,
        QUOTE_STATUS_ARRAY.Invoiced,
        QUOTE_STATUS_ARRAY.Voided,
        QUOTE_STATUS_ARRAY.Lost,
        QUOTE_STATUS_ARRAY.Cancelled,
        QUOTE_STATUS_ARRAY.Rejected,
        QUOTE_STATUS_ARRAY.PendingOrderConfirmation,
        QUOTE_STATUS_ARRAY.Dispatched,
        QUOTE_STATUS_ARRAY.Issued,
    ]),
}

export default QuoteStatusIcon
